import type { ThemeData } from '@group-link-one/gl-components';
import { SonarLightTheme } from './Themes/Sonarprint/Variants/SonarLight';

const SonarThemes: Record<string, ThemeData> = {
  'sonar-light': SonarLightTheme,
};

export { SonarThemes };
